__turbopack_context__.v({
  "modalContent": "NewOrderPanelSlot-module-scss-module__W8Ge1q__modalContent",
});
